'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {Avatar} from './components/Avatar';
import {AvatarDirective} from './directives/AvatarDirective';
import {AvatarUploadDirective} from './directives/AvatarUploadDirective';
import {DomainImage} from './components/DomainImage';
import {ImageContainer} from './components/Image/ImageContainer';
import {DomainImageDirective} from './directives/DomainImageDirective';
import {FileDomainProvider} from './domain/FileDomain';
import {FileDataUrlCache} from './services/FileDataUrlCache';
import {FileUrlCache} from './services/FileUrlCache';

const angular = require('angular');

module.exports = angular
  .module('app.files', [])
  .run(runInjector(Avatar))
  .run(runInjector(DomainImage))
  .run(runInjector(ImageContainer))
  .provider('FileDomain', FileDomainProvider)

  .service(FileDataUrlCache.SERVICE_NAME, FileDataUrlCache)
  .service('FileUrlCache', FileUrlCache)

  .directive('avatar', AvatarDirective)
  .directive('avatarUpload', AvatarUploadDirective)
  .directive('domainImage', DomainImageDirective)
;



// WEBPACK FOOTER //
// ./src/js/files/index.js